import React from "react";
import { LANDING } from "@/constants/testIds";
import { Quote } from "lucide-react";

const portrait1 =
  "https://images.unsplash.com/photo-1758691737644-ef8be18256c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxjb25maWRlbnQlMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXQlMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzgyMzk5ODY2fDA&ixlib=rb-4.1.0&q=85";
const portrait2 =
  "https://images.unsplash.com/photo-1758691737605-69a0e78bd193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxjb25maWRlbnQlMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXQlMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzgyMzk5ODY2fDA&ixlib=rb-4.1.0&q=85";
const portrait3 =
  "https://images.unsplash.com/photo-1449247709967-d4461a6a6103?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwY2xlYW4lMjBkZXNrJTIwd29ya3NwYWNlJTIwcGxhbnR8ZW58MHx8fHwxNzgyMzk5ODY3fDA&ixlib=rb-4.1.0&q=85";

const testimonials = [
  {
    name: "Devin Holloway",
    role: "COO · Northwind Manufacturing (212 employees)",
    quote:
      "Key Legacy Protection rebuilt our group life and comp programs in 90 days. We saved $186k in year one and our renewal next year went up by less than CPI.",
    img: portrait1,
    metric: "$186k saved · Year 1",
  },
  {
    name: "Priya Sundaram",
    role: "Founder · Hearth Studio (28 employees)",
    quote:
      "I'd dreaded benefits every renewal. Key Legacy Protection made it feel like an actual decision instead of a renewal letter I had to sign.",
    img: portrait2,
    metric: "98% employee enrollment",
  },
  {
    name: "Marcus Halverson",
    role: "President · Halverson Bros. Construction",
    quote:
      "Our last carrier denied a $400k workers' comp claim. The Key Legacy Protection claims advocate flipped it to approved in eleven days.",
    img: portrait3,
    metric: "Claim flipped in 11 days",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid={LANDING.testimonials}
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
        <div className="lg:col-span-6">
          <p className="label-eyebrow mb-4"><span className="text-accent">04</span> — Owners</p>
          <h2 className="font-display text-4xl md:text-5xl h-tight font-medium text-foreground">
            What the people who{" "}
            <span className="italic font-light text-accent">sign the checks</span> say.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <article
            key={i}
            data-testid={LANDING.testimonialCard(i)}
            className="relative bg-card border border-border rounded-md p-7 md:p-8 flex flex-col gap-6 shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300 overflow-hidden group"
          >
            <span className="absolute top-0 left-0 h-1 w-12 bg-accent group-hover:w-full transition-all duration-500" />
            <Quote size={28} className="text-accent" strokeWidth={1.5} />
            <p className="text-base md:text-lg leading-relaxed text-foreground">
              {t.quote}
            </p>
            <div className="pt-4 border-t border-border flex items-center gap-4">
              <img
                src={t.img}
                alt={t.name}
                className="h-12 w-12 rounded-full object-cover ring-2 ring-accent/60 ring-offset-2 ring-offset-background"
              />
              <div>
                <p className="font-display text-base font-semibold text-foreground">
                  {t.name}
                </p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
            <p className="label-eyebrow text-accent">{t.metric}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
